import { BooksList } from "components/BooksList";
import { EXTRALARGE, WHITE } from "shared/variables";
import { getSingle, getDocs } from "shared/prismic";
import { Intro } from "components/Intro";
import { MaxWidth } from "components/MaxWidth";
import { OverlapArea } from "components/OverlapArea";
import { Page } from "components/Page";
import { SpacingSection } from "components/SpacingSection";
import dynamic from "next/dynamic";

const ShopifyBuyButton = dynamic(() => import("components/ShopifyBuyButton"), {
  ssr: false,
});

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "book_overview" });
  const books = await getDocs({ previewData, type: "book_detail" });

  return { props: { doc, books, preview } };
}

const Index = ({ doc, books, preview }) => {
  const { items, intro, seo_title, seo_description, seo_image } = doc.data;
  const order = (items || []).map(({ item }) => item.uid);
  const booksInOrder = getBooksInOrder(books, order);

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      <OverlapArea>
        <MaxWidth>
          <Intro color={WHITE} title="Webshop" text={intro} />
        </MaxWidth>
      </OverlapArea>
      <SpacingSection onlyBottom size={EXTRALARGE}>
        <BooksList books={booksInOrder} />
      </SpacingSection>
      <ShopifyBuyButton />
    </Page>
  );
};

function getBooksInOrder(books, order) {
  const orderedBooks = order.map((uid) =>
    books.find((book) => book.uid === uid)
  );

  const booksNotInOrder = books.filter(
    (book) => order.indexOf(book.uid) === -1
  );

  return [...orderedBooks, ...booksNotInOrder];
}

export default Index;
